module.exports = __webpack_public_path__ + "assets/img/title-809844be.png";